const LanguageType = {
  EN: 'en',
  TR: 'tr',
}

export default LanguageType
